import styled from 'styled-components';
import { Spin, Tag } from 'antd';
import { GranularitySelect } from '@components/common';
import { ButtonLabel, ButtonWrapper } from '@src/styles/styled/mixins';

export const PanelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  margin: 3px 0px;
  padding: 2px 0;
  align-items: center;
  position: sticky;
  top: 0px;
  z-index: 9;
  background-color: #F5F5F5;
`;

export const StyledSpinner = styled(Spin)`
  margin: 0px 10px;
  vertical-align: middle;
`;

export const ToolbarWrapper = styled.div`
  .ant-radio-button-wrapper {
    background: transparent !important;
    border: 0px;
    border-right: 1px solid #aaa;
    box-shadow: none !important;
    height: 24px;
    line-height: 1.5;
    svg {
      vertical-align: middle;
    }
  }

  .ant-radio-button-wrapper-checked {
    svg path {
      fill: #0046ff;
    }
  }

  .ant-radio-button-wrapper:first-child {
    border-left: 1px solid #aaa;
    border-radius: 0;
  }
  .ant-radio-button-wrapper:last-child {
    border-right: 0px;
  }
  .ant-radio-button-wrapper::before {
    background-color: #aaa;
  }
`;

export const StyledGranularitySelect = styled(GranularitySelect)`

`;

export const StyledResizeWrapper = styled.div`
  ${ButtonWrapper}
`;

export const StyledResizeLabel = styled.div`
  ${ButtonLabel}
`;

export const StyledActionsWrapper = styled.div`
  ${ButtonWrapper}
`;

export const StyledActionsLabel = styled.div`
  ${ButtonLabel}
`;
